module.exports = __webpack_public_path__ + "img/speak.c85084b7.png";